API_URL = "https://api.estaly.co"

const PDP = {
    selectedPlanId: null,

    async init({variantReferenceId, merchantId, addToCartButtonClass, buyItNowButtonClass}) {
        if (!variantReferenceId) {
            return
        }


        const data = await Estaly.getOffers(variantReferenceId, merchantId);
        const offers = data.offers;
        const relevantOffer = offers.filter((offer) => offer.productVariantId === variantReferenceId)[0];
        const plans = relevantOffer.plans;

        this.insertPlans(plans);
        this.initButtons(variantReferenceId, addToCartButtonClass, buyItNowButtonClass);
        this.displayButtons();

        return this;
    },

    

    initButtons(variantReferenceId, addToCartButtonClass, buyItNowButtonClass) {
        const offerButtons = document.querySelectorAll(".offer-button")
        offerButtons.forEach((offerButton) => {
            offerButton.addEventListener("click", () => {
                if (offerButton.dataset.planVariantId == this.selectedPlanId) {
                    this.selectedPlanId = null;
                } else {
                    this.selectedPlanId = offerButton.dataset.planVariantId;
                }
                //this.setButtonsState();
            })
        })
    },

    displayButtons() {
        const offerButtonsContainer = document.querySelector(".estaly-pdp-offering");
        if (offerButtonsContainer) {
            offerButtonsContainer.style.display = "block";
        }
    },

    insertPlans(plans) {
        if (plans.length === 0) {
            return
        }

        const offerButtons = document.querySelectorAll(".offer-button")

        offerButtons.forEach((offerButton, index) => {
            const plan = plans[index % plans.length]

            offerButton.dataset.planVariantId = plan.offerVariantId

            const termLengthSpan = offerButton.querySelector(".offer-term-length")
            termLengthSpan.innerText = plan.termLength

            const priceSpan = offerButton.querySelector(".offer-price")
            priceSpan.innerText = plan.price
        })
    },

    addOfferToCart(variantReferenceId) {
        if (document.querySelector(".offer-button.active")) {
          var selectedPlanIdShopify = document.querySelector(".offer-button.active").dataset.planVariantId;
        } else {
          location.href="/cart";
        }

        if (Estaly.getSelectedVariantId()) {
            var selectedVariantId = Estaly.getSelectedVariantId;
        }
        else {
            var selectedVariantId = variantReferenceId;
        }

        const data = {
            items: [
                {
                    id: selectedPlanIdShopify,
                    quantity: 1,
                    properties: {
                        'VariantId': selectedVariantId
                    }
                },
            ]
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {
            id: selectedPlanIdShopify,
            quantity: 1,
            properties: {
                'VariantId': selectedVariantId
            },
            form_type:"product",
            utf8:"✓",
            success: function(){
              setTimeout(function () {
                location.href="/cart";
              }, 500);
            }
          }
        });
    },
}

const Estaly = {
    Widgets: {
        PDP: PDP,

        add(widget, params) {
            widget.init(params)
        }
    },

    state: {
        selectedOfferId: null
    },

    async addProductToCart(variantReferenceId) {
      PDP.addOfferToCart(variantReferenceId);
    },
  
    async getOffers(variantReferenceIds, merchantId) {
        const url = `${API_URL}/merchant/offers?reference_ids=${variantReferenceIds}`
        const response = await fetch(url, { headers: { Authorization: merchantId } })
        const data = await response.json()

        return data;
    },

    getSelectedVariantId() {
        selectedOffer = document.querySelector(".offer-button.active");
        return $("select[name='id']").val();
    },

    triggerUpdatePriceFinal() {
      const offerButtons = document.querySelectorAll('.offer-button');
      const priceFinal = document.querySelector('#price_final');
    
      // Ajouter un écouteur d'événement pour chaque bouton d'offre
      offerButtons.forEach((offerButton) => {
        offerButton.addEventListener("click", () => {
        
          const activeButton = document.querySelector(".offer-button.active");
          if (activeButton) {
            activeButton.classList.remove("active");
            const activePrice = parseFloat(activeButton.querySelector(".offer-price").textContent);
            const finalPrice = parseFloat(document.querySelector("#price_final").textContent);
            document.querySelector("#price_final").textContent = (finalPrice - activePrice) + "€";
          }

          const clickedButton = event.target.closest(".offer-button");
          
          if (activeButton === clickedButton ) {
            console.log("===");
            return;
          }
          
          clickedButton.classList.add("active");
          const newPrice = parseFloat(offerButton.querySelector(".offer-price").textContent);
          const finalPrice = parseFloat(document.querySelector("#price_final").textContent);
          document.querySelector("#price_final").textContent = (finalPrice + newPrice) + "€";
        });
      });
      
    },

    insertPlans(offers) {
        if (offers.length === 0) {
            return
        }

        const offerButtons = document.querySelectorAll(".offer-button")
        offerButtons.forEach((offerButton, index) => {
            const offer = offers[index % offers.length]

            offerButton.dataset.planVariantId = offer.offerVariantId;

            const termLengthSpan = offerButton.querySelector(".offer-term-length")
            termLengthSpan.innerText = offer.termLength

            const priceSpan = offerButton.querySelector(".offer-price")
            priceSpan.innerText = offer.price
        })
    },
}